import React, { useState, useEffect } from 'react';
import AMapLoader from "@amap/amap-jsapi-loader";
import { useLocation } from 'react-router-dom';
export default function Example() {
  // 声明一个新的叫做 “count” 的 state 变量
  const [count, setCount] = useState(0);

  let map = null;
  // 设置安全密钥
  window._AMapSecurityConfig = {
    securityJsCode: "3f653db0bd61c3e1ceb1f2ec878efbe1",
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const targetLat = queryParams.get('lat');
  const targetLng = queryParams.get('lng');

  useEffect(() => {
    AMapLoader.load({
      key: "b59bcb8005f877c7e9c00df89afbbb17",
      version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      // "plugins": [地图用到的插件],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      plugins: ["AMap.DistrictSearch", 'AMap.MoveAnimation', 'AMap.ImageLayer', 'AMap.TileLayer'],
    })
      .then((AMap) => {
        map = new AMap.Map("container", {
          // 设置地图容器id
          viewMode: "2D", // 是否为3D地图模式
          zoom: 11, // 初始化地图级别
          center: [116.397428, 39.90923], // 初始化地图中心点位置
          resizeEnable: true,
          cursor: "pointer",
          layers: [
            // AMap.createDefaultLayer(),
            //   imageLayer,
          ]
        });

        // 缩放地图到合适的视野级别
        map.setFitView();
        // map.setMapStyle("amap://styles/whitesmoke");
        // map.setDefaultCursor("pointer");

        setTimeout(() => {
          map.setZoomAndCenter(11, [120.950865, 30.662653]);


          AMap.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
              enableHighAccuracy: true,//高精定位，默认true，可不写
              timeout: 10000,// 设置获取定位后的加载时间
              buttonOffset: new AMap.Pixel(10, 20), // 定位按钮的偏移量
              zoomToAccuracy: true,
              buttonPosition: 'RB'//设置定位按钮的显示位置
            })

            geolocation.getCurrentPosition(function (status, result) {
              console.log(result.info);
              if (result.info == 'SUCCESS') {
                let { lat, lng } = result.position;
                AMap.plugin(["AMap.Driving"], function () {
                  const driving = new AMap.Driving({
                    map: map,
                  });
                  //获取起终点规划线路
                  driving.search(new AMap.LngLat(lng, lat), new AMap.LngLat(targetLng, targetLat), function (status, result) {
                    if (status === "complete") {
                      //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                      //查询成功时，result 即为对应的驾车导航信息
                      console.log(result);
                    } else {
                      console.log("获取驾车数据失败：" + result);
                    }
                  });
                });
              }


              if (status == 'complete') {
                // onComplete(result)
                console.log(result);
              } else {
                // onError(result)
              }
            })
          });


        }, 600)



        //构造路线导航类
        // let driving = new AMap.Driving({
        //   map: map,
        //   panel: "panel"
        // });
        // // 根据起终点名称规划驾车导航路线
        // driving.search([
        //   { keyword: '北京市地震局(公交站)', city: '北京' },
        //   { keyword: '亦庄文化园(地铁站)', city: '北京' }
        // ], function (status, result) {
        //   // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        //   if (status === 'complete') {
        //     console.log('绘制驾车路线完成')
        //   } else {
        //     console.error('获取驾车数据失败：' + result)
        //   }
        // });
      })
      .catch((e) => {
        console.log(e);
      });

    return () => {
      map?.destroy();
    };
  }, []);

  return (
    <div>
      <div
        id="container"
        style={{ height: "100vh", zIndex: 2, pointerEvents: "all" }}
      ></div>
    </div>
  );
}